import React from "react";
import aboutImage from "../assets/pion.png"; // replace with your image
import { useNavigate } from "react-router-dom";
import { HOME_PAGE } from "../data/constants";

const Pioneering = () => {
  const navigate = useNavigate();
  return (
    <section className="bg-[#F5F7FA] px-6 md:px-20 md:py-[120px] pt-[30px] pb-[64px]">
      <div className=" items-start flex flex-row justify-between">
        {/* Left Text */}
        <div>
          <h2 className="font-utility font-medium  leading-[120%] tracking-[-0.01em] align-middle capitalize text-[#011621] mb-8 text-[30px] sm:text-[54px]">
            {HOME_PAGE.pioneering.heading.split("\n").map((line, i) => (
              <React.Fragment key={i}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </h2>
          <p className="font-inter font-normal text-[18px] leading-[150%] tracking-[-0.005em] text-[#033652] mb-8 max-w-xl sm:text-[20px]">
            {HOME_PAGE.pioneering.description}
          </p>
    <button
  className="
    bg-[#033652] text-white text-[16px]
    px-6 py-2 font-medium sm:text-lg
    w-[170px] h-[52px]
    overflow-hidden
    [clip-path:polygon(0_0,100%_0,100%_100%,0_100%)]
    hover:bg-[#46C1BF] hover:text-black
    hover:[clip-path:polygon(0_0,100%_0,100%_calc(100%_-_16px),calc(100%_-_16px)_100%,0_100%)]
    transition-all duration-300
    active:bg-[#3CACAF]
  "
  onClick={() => navigate("/about")}
>
  {HOME_PAGE.pioneering.aboutButton}
</button>


        </div>

        {/* Right Image with Custom Cut */}
        <div className="hidden min-[700px]:block min-[1300px]:w-[510px] min-[1300px]:h-[538px] min-[700px]:w-[300px] min-[700px]:h-[300px]">
            <img
              src={aboutImage}
              alt="About"
              className="w-full h-full object-contain"
              loading="lazy"
            />
        </div>
      </div>
    </section>
  );
};

export default Pioneering;
